import React from 'react';
import { pdf } from '@react-pdf/renderer';
import { PlantingEstimatePdfDocument } from './PlantingEstimatePdfDocument';
import { downloadBlob } from '../../../utils/downloadBlob';

export function getPlantingExportLogoUrl() {
  if (typeof window === 'undefined') return '';
  const base = process.env.PUBLIC_URL || '';
  return `${window.location.origin}${base}/brand/yona-bear-2.png`;
}

export async function downloadPlantingEstimatePdf(data) {
  const logoUrl = getPlantingExportLogoUrl();
  const blob = await pdf(
    <PlantingEstimatePdfDocument data={data} logoUrl={logoUrl} />
  ).toBlob();

  downloadBlob(blob, data.filename || 'yona-planting-estimate.pdf');
}
